<template>
  <div class="text-center">
    <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1000" v-model="dialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          THÊM GIÁO VIÊN VÀO LỚP BÁN TRÚ "{{ boardingClass.name }}"
          <v-spacer />
          <v-btn dark icon>
            <v-icon @click="closeDialog">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card outlined class="pa-4 my-4 elevation-0">
            <v-row>
              <v-col cols="12" md="10">
                <v-row>
                  <v-col cols="12" md="6" class="pb-0">
                    <AutocompleteTeacherCard
                      :syncedValue.sync="teacher"
                      clearable
                      clear-icon="mdi-close"
                      outlined
                      label="Giáo viên"
                      dense
                      deletable-chips
                      hide-details
                    />
                  </v-col>
                  <v-col cols="4" class="pb-0"> </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn class="search-button" color="#0D47A1" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
              </v-col>
            </v-row>
          </v-card>

          <!-- table -->
          <v-card outlined class="my-4 elevation-0">
            <TeacherDataTable showSelect ref="teacherDataTable" :propHeaders="headers" :selected.sync="selecteds" />
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <div class="d-flex justify-space-between align-center" style="width: 100%">
            <v-btn color="gray" class="ma-2 px-8" @click="closeDialog" outlined>Hủy</v-btn>
            <div>
              Đã chọn {{ selecteds.length }} giáo viên
              <v-btn color="primary" class="elevation-0 px-8 mx-2" @click="save">Thêm</v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard.vue'
import TeacherDataTable from '@/modules/teacher/TeacherDataTable.vue'

export default {
  components: {
    AutocompleteClass,
    AutocompleteTeacherCard,
    TeacherDataTable,
  },
  data() {
    return {
      currentClass: null,
      teacher: null,
      dialog: false,
      selecteds: [],
      headers: [
        { text: 'Tên giáo viên', value: 'name' },
        { text: 'Ngày sinh', value: 'dob' },
        { text: 'Trạng thái', value: 'status' },
      ],
    }
  },
  computed: {
    ...mapGetters({ boardingClass: 'boardingClass/item' }),
  },
  methods: {
    ...mapActions('boardingClassTeacher', ['addMany', 'fetchItems']),
    ...mapActions('teachers', ['searchTeachers']),
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    onFilterChanged() {
      const params = { id: get(this.teacher, 'id') }
      this.searchTeachers(params)
    },
    save() {
      this.$dialog.confirm({
        title: 'Thêm giáo viên',
        text: ` Bạn có chắc chắn muốn thêm ${this.selecteds.length} giáo viên vào lớp bán trú ?`,
        okText: 'OK',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.addMany({
              id: this.boardingClass.id,
              teachers: this.selecteds.map(x => x.id),
            })
            await this.fetchItems({ _sort: 'nameToNumber:ASC', boardingClasses: this.$route.params.id })
            this.$alert.addSuccess()
            this.dialog = false
          } catch (error) {
            this.$alert.addError()
          }
        },
      })
    },
  },
}
</script>
